import VehicleList from './container';
export default VehicleList;
